var exports = {
  "kL": "x31de4314--8b9b3e--container",
  "Sl": "x31de4314--8b9b3e--image",
};

module.exports = exports;
